var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { isArr, isFn, isPlainObj, isStr, reduce } from '@formily/shared';
import { isObservable } from '@formily/reactive';
import { Schema } from './schema';
var ExpRE = /^\s*\{\{([\s\S]*)\}\}\s*$/;
var actionsSymbol = Symbol.for('__REVA_ACTIONS');
var ENVS = {
    compile: function (expression, scope) {
        var vars = Object.keys(scope || {});
        var params = vars.map(function (key) { return scope[key]; });
        return new (Function.bind.apply(Function, __spread([void 0], vars, ["return (" + expression + ");"])))().apply(void 0, __spread(params));
    },
};
export var registerCompiler = function (compiler) {
    if (isFn(compiler)) {
        ENVS.compile = compiler;
    }
};
export var shallowCompile = function (source, scope) {
    if (isStr(source)) {
        var matched = source.match(ExpRE);
        if (!matched)
            return source;
        return ENVS.compile(matched[1], scope);
    }
    else if (isArr(source)) {
        return source.map(function (item) { return shallowCompile(item, scope); });
    }
    return source;
};
export var compile = function (source, scope) {
    var seenObjects = new WeakMap();
    var compile = function (source) {
        if (isStr(source)) {
            return shallowCompile(source, scope);
        }
        else if (isArr(source)) {
            return source.map(function (value) { return compile(value); });
        }
        else if (isPlainObj(source)) {
            if ('$$typeof' in source && '_owner' in source) {
                return source;
            }
            if (source[actionsSymbol]) {
                return source;
            }
            if (source['_isAMomentObject']) {
                return source;
            }
            if (Schema.isSchemaInstance(source)) {
                return source.compile(scope);
            }
            if (isFn(source['toJS'])) {
                return source;
            }
            if (isFn(source['toJSON'])) {
                return source;
            }
            if (isObservable(source)) {
                return source;
            }
            if (seenObjects.get(source)) {
                return source;
            }
            seenObjects.set(source, true);
            var results = reduce(source, function (buf, value, key) {
                buf[key] = compile(value);
                return buf;
            }, {});
            seenObjects.set(source, false);
            return results;
        }
        return source;
    };
    return compile(source);
};
